import TLNyoutubeBtn from '../images/TLNbannerButton400.jpg';

function TLNyoutubeBtnEmbed(){
    return (
        <>
        <img src={TLNyoutubeBtn} alt="TrueLibertyNorth YouTube Button" className="faithImage embedRound" />
        </>
    );
};
export default TLNyoutubeBtnEmbed;